import { StrategyElement } from '@ndvr/portfolio-api';

import { formatWeightForSave } from '../../shared-utils';
import { StrategyElementFormValue } from './model-form-schema';

/** Maps the model form's strategy elements to the shape both with-strategies endpoints expect. */
export const toStrategyElementsRequest = (elements: StrategyElementFormValue[]): StrategyElement[] =>
    elements.map((el) =>
        el.mode === 'existing'
            ? { existingStrategyGUID: el.existingStrategyGUID!, weight: formatWeightForSave(el.weight) }
            : {
                  weight: formatWeightForSave(el.weight),
                  newStrategy: {
                      strategyName: el.newStrategyName!.trim(),
                      assetAllocations: (el.newStrategyAssetAllocations || []).map((asset) => ({
                          ...asset,
                          weight: formatWeightForSave(asset.weight),
                      })),
                  },
              },
    );
